import VideoRecordIcon from '@atlaskit/icon-lab/core/video-record';
import * as React from 'react';

export function SvgRecord() {
  return <VideoRecordIcon label="" testId="ads-refreshed-icon" />;
}
